import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class DummyNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.Dummy,
    });
  }
}
